import type { GetRenewedImpactResponse } from './renewed-impact'

export const getRenewedImpactMock: GetRenewedImpactResponse = {
  title: 'The impact of refurbished',
  image: 'IllustrationEarth',
  paragraphs: [
    {
      icon: 'IconLeaf',
      title: 'Helps prevent toxic e-waste',
      text: 'E-waste is toxic — like lead and mercury in your water toxic. On average, a single refurbished smartphone prevents 6.3 oz of e-waste from ending up in our landfills.',
    },
    {
      icon: 'IconCircle',
      title: 'Reuses raw metals',
      text: 'Gold, aluminum, copper, and other raw materials are needed to build a new smartphone. Refurbished smartphones help us get the most out of the resources that have already been dug up.',
    },
    {
      icon: 'IconThumbsUp',
      title: 'Crushes your carbon footprint',
      text: 'Manufacturing a new smartphone produces about 170.4 lbs of carbon emissions (CO2e). Refurbishing? Just 15.6 lbs, on average.',
    },
    {
      icon: 'IconGlasses',
      title: 'More on the numbers',
      text: 'Data for the impact of refurbished versus brand new electronics come from ADEME’s 2022 global study. ADEME is the French Environment and Energy Management.',
    },
  ],
  links: [
    {
      link: {
        type: 'internal',
        name: 'article',
        pattern: '/:locale/c/:category/:pageName',
        params: {
          category: 'news',
          pageName: 'impact-of-refurbished-on-environment',
          locale: 'en-us',
        },
        query: {},
        hash: {},
        href: 'https://www.backmarket.com/en-us/c/news/impact-of-refurbished-on-environment',
      },
      title: 'Read on',
    },
  ],
}
